module.exports = __webpack_public_path__ + "static/media/icone-exames-externos.88656980.svg";